var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-jsf',{attrs:{"schema":_vm.schema,"options":_vm.options},on:{"input":function($event){return _vm.$emit('update:model', $event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }